module.exports = __webpack_public_path__ + "img/Cat.27acd387.svg";